import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../contexts/AuthContext';
import { getBackendBaseUrl } from '../utils/backendBaseUrl';
import { getConsent } from '../privacy/consent';

const API_URL = getBackendBaseUrl();

export default function PageViewTracker() {
  const location = useLocation();
  const { currentUser } = useAuth();

  useEffect(() => {
    let cancelled = false;

    const track = async () => {
      try {
        const consent = getConsent();
        if (!consent || !consent.analytics) return;
        if (!currentUser) return;
        const token = await currentUser.getIdToken();
        if (cancelled) return;

        await axios.post(
          `${API_URL}/api/track/page-view`,
          { path: location.pathname },
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
      } catch {
        // non-blocking
      }
    };

    track();

    return () => {
      cancelled = true;
    };
  }, [location.pathname, currentUser]);

  return null;
}
